module["exports"] = [
  "Dr.",
  "Prof."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/name/prefix.js
 ** module id = 773
 ** module chunks = 0
 **/